<template>
  <div class="lnb">
    <div class="lnbLogo">
      <router-link to="/admin/dashboard">
        <img src="@/assets/images/logo.svg" alt="로고" />
      </router-link>
    </div>
    <el-row class="tac mainMenu">
      <el-col :span="12">
        <el-menu class="el-menu-vertical-demo" :default-active="navbarState">
          <el-menu-item index="0">
            <router-link to="/admin/dashboard">
              <span>
                <span class="material-icons-round"> space_dashboard </span>
                <!-- <img
                  src="@/assets/images/icon_svg/LNB_dashboard.svg"
                  alt="icon"
                  class="normal"
                /> -->
                대시보드
              </span>
            </router-link>
          </el-menu-item>
          <el-menu-item index="1">
            <router-link to="/admin/users?page=1">
              <span>
                <span class="material-icons-round"> people_alt </span>
                <!-- <img
                  src="@/assets/images/icon_svg/LNB_group.svg"
                  alt="icon"
                  class="normal"
                /> -->
                회원 관리
              </span>
            </router-link>
          </el-menu-item>
          <el-menu-item index="8">
            <router-link to="/admin/subscriptions/manage?page=1">
              <span>
                <span class="material-icons-round"> card_membership </span>
                구독 관리
              </span>
            </router-link>
          </el-menu-item>

          <el-menu-item index="2">
            <router-link to="/admin/word/manage">
              <span>
                <!-- <img
                  src="@/assets/images/icon_svg/LNB_word.svg"
                  alt="icon"
                  class="normal"
                /> -->
                <span class="material-icons-round"> format_size </span>
                단어 관리
              </span>
            </router-link>
          </el-menu-item>
          <el-menu-item index="3">
            <router-link to="/admin/sentence/manage">
              <span>
                <!-- <img
                  src="@/assets/images/icon_svg/LNB_sentence.svg"
                  alt="icon"
                  class="normal"
                /> -->
                <span class="material-icons-round">
                  drive_file_rename_outline
                </span>
                단어 퀴즈 관리
              </span>
            </router-link>
          </el-menu-item>
          <el-menu-item index="4">
            <router-link to="/admin/video/manage">
              <span>
                <!-- <img
                  src="@/assets/images/icon_svg/LNB_vod_manage.svg"
                  alt="icon"
                  class="normal"
                /> -->
                <span class="material-icons-round"> smart_display </span>
                비디오 학습 관리
              </span>
            </router-link>
          </el-menu-item>
          <el-menu-item index="5">
            <router-link to="/admin/listening/manage">
              <span>
                <span class="material-icons-round"> headphones </span>
                리스닝 학습 관리
              </span>
            </router-link>
          </el-menu-item>
          <el-menu-item index="6">
            <router-link to="/admin/level-test/problems/manage">
              <span>
                <span class="material-icons-round"> fact_check </span>
                레벨 테스트 관리
              </span>
            </router-link>
          </el-menu-item>
          <el-menu-item index="7">
            <router-link to="/admin/feedback/manage">
              <span>
                <span class="material-icons-round"> feedback </span>
                피드백 관리
              </span>
            </router-link>
          </el-menu-item>
          <el-menu-item index="99">
            <router-link to @click.native="logout">
              <span>
                <span class="material-icons-round"> logout </span>
                로그아웃
              </span>
            </router-link>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      isActive: false,
      isDropped: false,
    };
  },
  computed: {
    ...mapState(["navbarState", "certifyRequestCount"]),
  },

  methods: {
    logout() {
      let result = confirm("로그아웃 하시겠습니까?");
      if (result == false) {
        return;
      }
      this.$store.dispatch("LOGOUT");
    },
  },
};
</script>
